import { Schemas } from '~/api/gen'
import { Chip } from '~/components/elements/Chip'
import { buildUrl } from '~/features/shared/search/coordinate/builder/buildUrl'

type Props = {
  tags: Schemas.tag[]
}
export const TagList: React.FC<Props> = ({ tags }) => {
  return (
    <ul className="flex flex-wrap gap-[5px]">
      {tags.map(({ name, id }) => (
        <li key={id}>
          <Chip
            href={buildUrl({
              tagIds: [id],
            })}
          >
            {`#${name}`}
          </Chip>
        </li>
      ))}
    </ul>
  )
}
